import script from "./EngineFeatureComp.vue?vue&type=script&setup=true&lang=js"
export * from "./EngineFeatureComp.vue?vue&type=script&setup=true&lang=js"

import "./EngineFeatureComp.vue?vue&type=style&index=0&id=0f0986af&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f0986af"]])

export default __exports__